'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addYears;


// WEBPACK FOOTER //
// ./~/sugar-date/date/addYears.js